import React from "react";
import { Input, ToggleSwitch } from "../../../../components";
import { useTranslations } from "../../../../contexts";
import { SidebarFormProps } from "./SidebarForm";
import { DesignerSectionHeading } from "./DesignerSectionHeading";

export const SidebarFormText: React.FC<SidebarFormProps> = (props) => {
  const i18n = useTranslations();

  return (
    <div className="border-b p-6" data-preview-section="text">
      <div className="flex items-start">
        <DesignerSectionHeading
          className="grow pb-4"
          title={i18n.Text}
          helpLabel={`${i18n.designerHelpFor} ${i18n.Text}`}
          helpText={i18n.designerTextHelp}
        />
        <ToggleSwitch
          aria-label={`${i18n.designerShowSection}: ${i18n.Text}`}
          checked={props.form.text?.is_enabled}
          onChange={() =>
            props.setForm({
              ...props.form,
              text: {
                ...props.form.text,
                is_enabled: !props.form.text?.is_enabled,
              },
            })
          }
        />
      </div>
      {props.form.text?.is_enabled && (
        <Input
          asTextarea
          rows={8}
          placeholder={i18n["Type your text here..."]}
          example={i18n.designerTextPlaceholder}
          help={{
            label: `${i18n.designerHelpFor} ${i18n["Type your text here..."]}`,
            content: i18n.designerTextContentHelp,
          }}
          value={props.form.text?.content || ""}
          onChange={(event) =>
            props.setForm({
              ...props.form,
              text: {
                ...props.form.text,
                content: event.target.value,
              },
            })
          }
        />
      )}
    </div>
  );
};
